import { render, staticRenderFns } from "./trendyProducts.vue?vue&type=template&id=822577f2&scoped=true"
import script from "./trendyProducts.vue?vue&type=script&lang=js"
export * from "./trendyProducts.vue?vue&type=script&lang=js"
import style0 from "./trendyProducts.vue?vue&type=style&index=0&id=822577f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822577f2",
  null
  
)

export default component.exports